(() => {
    HuiNavWrapperController.$inject = ['$scope'];

    function HuiNavWrapperController($scope) {
        const self = this;

    }

    angular
        .module("harriApp")
        .directive("huiNavWrapper", function () {
            return {
                restrict: 'E',
                replace: true,
                scope: true,
                transclude: true,
                bindToController: {
                    open: '<',
                    classNames: '<',
                },
                controllerAs: '$ctrl',
                controller: HuiNavWrapperController,
                templateUrl: `../hmodules/harri-main/ui-components/hui-nav-wrapper.html`
            }
        });

})();